export const CTA = {
    HOMEPAGE_POPUP_OFFER: 'homepage-offer-popup',
    HOMEPAGE_POPUP_SUBSCRIBE: 'homepage-subscribe-popup',

    POST_POPUP_SUBSCRIBE: 'classic-popup-box',
    POST_POPUP_DISCOUNT: 'classic-popup-box-discount',
    POST_POPUP_UPGRADE: 'classic-popup-box-upgrade',
    POST_POPUP_LINK: 'classic-popup-box-link',
    POST_POPUP_NO_BUTTON: 'classic-popup-no-button',
    POST_POPUP_WIDE_MODERN: 'wide-modern-popup',

    PAYWALL_SUBSCRIBE: 'paywall-subscribe-popup',
    PAYWALL_UPGRADE: 'paywall-upgrade-popup',
}

export const HOMEPAGE_CTA = [
    CTA.HOMEPAGE_POPUP_OFFER,
    CTA.HOMEPAGE_POPUP_SUBSCRIBE,
]

export const DISABLE_SCROLL_CTA = [
    CTA.HOMEPAGE_POPUP_OFFER,
    CTA.HOMEPAGE_POPUP_SUBSCRIBE,
    CTA.POST_POPUP_SUBSCRIBE,
    CTA.POST_POPUP_DISCOUNT,
    CTA.POST_POPUP_UPGRADE,
    CTA.POST_POPUP_LINK,
    CTA.POST_POPUP_NO_BUTTON,
    CTA.POST_POPUP_WIDE_MODERN,
    CTA.PAYWALL_SUBSCRIBE,
    CTA.PAYWALL_UPGRADE,
]


